"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _lego = require("@zz-common/lego");
var _excluded = ["infoid", "infoId", "sectionid", "sectionId", "sortname", "sortName", "sortid", "sortId", "url", "other", "areaexposure", "isdot", "metric", "info", "goodsexposure", "legoareabackup"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function getQueryString(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var link = location.href;
  if (url) link = url;
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(link) || ['', ''])[1].replace(/\+/g, '%20')) || '';
}
var infoId_ = getQueryString('infoId') || getQueryString('zz_product_id');
function setAttributes(element, attrs) {
  Object.keys(attrs).forEach(function (key) {
    if (attrs[key] !== undefined && attrs[key] !== null && attrs[key] !== "") {
      element.setAttribute(key, attrs[key]);
    }
  });
}
var zpm = function zpm() {
  for (var _len = arguments.length, legoConfig = new Array(_len), _key = 0; _key < _len; _key++) {
    legoConfig[_key] = arguments[_key];
  }
  var callback = function callback(el, binding) {
    var _binding$value = binding.value,
      _binding$value$infoid = _binding$value.infoid,
      infoid = _binding$value$infoid === void 0 ? '' : _binding$value$infoid,
      _binding$value$infoId = _binding$value.infoId,
      infoId = _binding$value$infoId === void 0 ? '' : _binding$value$infoId,
      _binding$value$sectio = _binding$value.sectionid,
      sectionid = _binding$value$sectio === void 0 ? '' : _binding$value$sectio,
      _binding$value$sectio2 = _binding$value.sectionId,
      sectionId = _binding$value$sectio2 === void 0 ? '' : _binding$value$sectio2,
      _binding$value$sortna = _binding$value.sortname,
      sortname = _binding$value$sortna === void 0 ? '' : _binding$value$sortna,
      _binding$value$sortNa = _binding$value.sortName,
      sortName = _binding$value$sortNa === void 0 ? '' : _binding$value$sortNa,
      _binding$value$sortid = _binding$value.sortid,
      sortid = _binding$value$sortid === void 0 ? '' : _binding$value$sortid,
      _binding$value$sortId = _binding$value.sortId,
      sortId = _binding$value$sortId === void 0 ? '' : _binding$value$sortId,
      _binding$value$url = _binding$value.url,
      url = _binding$value$url === void 0 ? '' : _binding$value$url,
      _binding$value$other = _binding$value.other,
      other = _binding$value$other === void 0 ? '' : _binding$value$other,
      _binding$value$areaex = _binding$value.areaexposure,
      areaexposure = _binding$value$areaex === void 0 ? '' : _binding$value$areaex,
      _binding$value$isdot = _binding$value.isdot,
      isdot = _binding$value$isdot === void 0 ? '' : _binding$value$isdot,
      _binding$value$metric = _binding$value.metric,
      metric = _binding$value$metric === void 0 ? '' : _binding$value$metric,
      _binding$value$info = _binding$value.info,
      info = _binding$value$info === void 0 ? '' : _binding$value$info,
      _binding$value$goodse = _binding$value.goodsexposure,
      goodsexposure = _binding$value$goodse === void 0 ? '' : _binding$value$goodse,
      _binding$value$legoar = _binding$value.legoareabackup,
      legoareabackup = _binding$value$legoar === void 0 ? '' : _binding$value$legoar,
      backup = _objectWithoutProperties(_binding$value, _excluded);
    var zpm_attrs = {
      'zz-infoid': infoid || infoId || infoId_,
      'zz-sectionid': sectionid || sectionId,
      'zz-sortid': sortid || sortId || 0,
      'zz-sortname': sortname || sortName,
      'zz-url': url,
      'zz-other': other,
      'data-areaexposure': areaexposure,
      'lego-goods-exposure': goodsexposure ? JSON.stringify(goodsexposure) : '',
      'data-isdot': isdot,
      'data-metric': metric,
      'data-info': info ? JSON.stringify(info) : '',
      'zz-backup': backup && Object.keys(backup).length ? JSON.stringify(backup) : '',
      'lego-area-backup': legoareabackup ? JSON.stringify(legoareabackup) : ''
    };
    setAttributes(el, zpm_attrs);
  };
  var params = legoConfig[0];
  _vue.default.directive('zpm', {
    inserted: callback,
    update: callback
  });
  if (legoConfig) {
    _vue.default.prototype.$lego = _lego.lego;
    _vue.default.prototype.$legoAreaExposure = _lego.legoAreaExposure;
    _vue.default.prototype.$legoGoodsExposure = _lego.legoGoodsExposure;
    _vue.default.prototype.$legoInit = function () {
      var _config$;
      for (var _len2 = arguments.length, config = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        config[_key2] = arguments[_key2];
      }
      if ((_config$ = config[0]) !== null && _config$ !== void 0 && _config$.infoId) {
        infoId_ = config[0].infoId;
      }
      (0, _lego.legoInit)(Object.assign.apply(Object, [{}].concat(legoConfig, config)));
    };
    Object.assign(_vue.default.prototype.$legoInit, _lego.legoInit);
    _vue.default.prototype.$legoSend = function (pagetype, actiontype, backup) {
      try {
        var _params$routeList;
        if ((params === null || params === void 0 ? void 0 : (_params$routeList = params.routeList) === null || _params$routeList === void 0 ? void 0 : _params$routeList.length) == 1 && _typeof(actiontype) == 'object' && !backup) {
          _lego.lego.send({
            pagetype: pagetype,
            actiontype: params.routeList[0].pageId,
            backup: actiontype
          });
        } else {
          _lego.lego.send({
            pagetype: pagetype,
            actiontype: actiontype,
            backup: backup
          });
        }
      } catch (error) {
        console.log("[error] legoSend:", error);
      }
    };
  }
};
var _default = zpm;
exports.default = _default;